/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_Hint_PropertyInputs */

const cs_ruian_hint_property = /** @type {(inputs: Ruian_Hint_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte adresu nebo ulici. Vyplníme co RÚIAN zná; číslo popisné doplňte, pokud chybí.`)
};

const en_ruian_hint_property = /** @type {(inputs: Ruian_Hint_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick an address or street. We fill what RÚIAN knows; add the house number if it is missing.`)
};

/**
* | output |
* | --- |
* | "Pick an address or street. We fill what RÚIAN knows; add the house number if it is missing." |
*
* @param {Ruian_Hint_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_hint_property = /** @type {((inputs?: Ruian_Hint_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_Hint_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_hint_property(inputs)
	return cs_ruian_hint_property(inputs)
});